import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ListItemButton, ListItemIcon, ListItemText, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

// 1. Importamos todos los iconos necesarios de FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faCalendarAlt, 
    faGifts, 
    faUser, 
    faShoppingCart, 
    faTableCellsLarge, // Reemplazo visual para Dashboard
    faBoxOpen, // O faReceipt, para Mis Pedidos
    faBriefcase //Workspace 
} from '@fortawesome/free-solid-svg-icons';

import { getWorkspaces } from '../../controllers/customer/workspaces/WorkspacesController';

// Componente Item Estandarizado
const NavItem = ({ icon, label, path, onClick, isActive }) => {
    const theme = useTheme();

    return (
        <ListItemButton
            onClick={onClick}
            sx={{
                minHeight: 44,
                px: 2,
                mb: 1,
                borderRadius: '8px',
                backgroundColor: isActive ? theme.palette.primary.main + '15' : 'transparent',
                color: isActive ? theme.palette.primary.main : theme.palette.text.secondary,
                borderLeft: isActive ? `4px solid ${theme.palette.primary.main}` : '4px solid transparent',
                '&:hover': {
                    backgroundColor: isActive 
                        ? theme.palette.primary.main + '25'
                        : 'rgba(0, 0, 0, 0.04)',
                },
                transition: 'all 0.2s',
            }}
        >
            <ListItemIcon
                sx={{
                    minWidth: 36,
                    color: 'inherit',
                    display: 'flex',
                    justifyContent: 'center' // Centra el icono en su espacio
                }}
            >
                {/* Renderizamos el icono aquí */}
                {icon}
            </ListItemIcon>
            
            <ListItemText 
                primary={
                    <Typography variant="body2" fontWeight={isActive ? 'bold' : 'medium'}>
                        {label}
                    </Typography>
                } 
            />
        </ListItemButton>
    );
};

export default function MainListItems() {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation(); 

    const [workspaces, setWorkspaces] = useState([]);
    
    const redireccionar = (ruta) => history.push(ruta);

    const isPathActive = (path) => {
        if (path === '/' && location.pathname === '/') return true;
        if (path !== '/' && location.pathname.startsWith(path)) return true;
        return false;
    };


    useEffect(() => {
        const fetchWorkspaces = async () => {
            // Llamamos a la función de tu controlador frontend que ejecuta el api.get
            let response = await getWorkspaces(); 
            if (response && response.success && response.data.workspaces) {
                setWorkspaces(response.data.workspaces);
            }
        };
        fetchWorkspaces();
    }, []);

    // --- LÓGICA DE REDIRECCIÓN INTELIGENTE ---
    const handleWorkspacesClick = () => {
        if (workspaces.length === 1) {
            localStorage.setItem('work_mode_merchant_id', workspaces[0].merchant_id);
            redireccionar(`/workspaces/${workspaces[0].merchant_id}`);
        } else if (workspaces.length > 1) {
            redireccionar('/workspaces');
        }
    };

    return (
        <>            
            <NavItem 
                label="Dashboard"
                path="/"
                // Usamos fixedWidth para asegurar alineación vertical perfecta
                icon={<FontAwesomeIcon icon={faTableCellsLarge} fixedWidth />} 
                isActive={isPathActive('/')}
                onClick={() => redireccionar('/')}
            />

            <NavItem 
                label={t('helpers.profile')}
                path="/profile"
                icon={<FontAwesomeIcon icon={faUser} fixedWidth />}
                isActive={isPathActive('/profile')}
                onClick={() => redireccionar('/profile')}
            />

            <NavItem 
                label="Carrito de compras"
                path="/cart"
                icon={<FontAwesomeIcon icon={faShoppingCart} fixedWidth />}
                isActive={isPathActive('/cart')}
                onClick={() => redireccionar('/cart')}
            />

            <NavItem 
                label={t('orders.title')} // Ajustado título
                path="/orders"      // Ajustada ruta a la lista general
                icon={<FontAwesomeIcon icon={faBoxOpen} fixedWidth />}
                isActive={isPathActive('/orders')}
                onClick={() => redireccionar('/orders')}
            />

            <NavItem 
                label={t('helpers.coupons')}
                path="/coupons"
                icon={<FontAwesomeIcon icon={faGifts} fixedWidth />}
                isActive={isPathActive('/coupons')}
                onClick={() => redireccionar('/coupons')}
            />

            <NavItem 
                label={t('helpers.reservations')}
                path="/reservations"
                icon={<FontAwesomeIcon icon={faCalendarAlt} fixedWidth />}
                isActive={isPathActive('/reservations')}
                onClick={() => redireccionar('/reservations')}
            />

            {workspaces.length > 0 && (
                <NavItem 
                    label="Workspaces"
                    path="/workspaces"
                    icon={<FontAwesomeIcon icon={faBriefcase} fixedWidth />}
                    // Lo marcamos activo si está en la vista de selección o dentro de la taquilla
                    isActive={isPathActive('/workspaces') || isPathActive(`/workspaces/${localStorage.getItem('work_mode_merchant_id')}`)}
                    onClick={handleWorkspacesClick}
                />
            )}
        </>
    );    
}